import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/aica.svg";
import data from "../language.json";
import languageContext from "../context/language/languageContext";

const FrontPage = () => {
  const navigate = useNavigate();
  const { setLang } = useContext(languageContext);
  const currentPagePath = window.location.pathname;

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const handleLanguageChange = (event) => {
    const selectedLanguageIndex = event.target.value;
    if (selectedLanguageIndex !== "") {
      setLang(selectedLanguageIndex);
      localStorage.setItem("lang", selectedLanguageIndex);
      const loginBool = localStorage.getItem("login");
      if (loginBool === "true") {
        navigate("/ask", { state: { url: currentPagePath } });
      } else {
        navigate("/login", { state: { url: currentPagePath } });
      }
    }
  };

  return (
    <div className="w-full flex flex-col items-center justify-start text-center font-bold bg-white h-screen pt-16">
      {/* Logo Section */}
      <div className="flex flex-col justify-center items-center mb-8 animate-fadeIn">
        <img
          className="w-3/4 sm:w-1/2 md:w-1/3 lg:w-1/4 mb-4 drop-shadow-lg"
          src={logo}
          alt="frontPagePic"
        />
        <h1 className="text-gray-900 font-bold text-center text-4xl sm:text-5xl md:text-6xl">
          Welcome, Parents
        </h1>
      </div>

      {/* Subtitle Section */}
      <p className="text-gray-700 text-lg sm:text-xl md:text-2xl mb-6 font-medium text-center">
        Please choose your preferred language to continue
      </p>

      {/* Language Selector */}
      <div className="w-full max-w-md mb-6 relative">
        <select
          onChange={handleLanguageChange}
          className="bg-white border-2 border-[#A6C7E3] w-full py-3 px-4 rounded-lg text-gray-800 shadow-md focus:outline-none focus:ring-2 focus:ring-[#A8D4E7] transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-lg cursor-pointer"
        >
          <option value="">Select Language</option>
          {data.map((language) => (
            <option key={language.index} value={language.index}>
              {capitalizeFirstLetter(language.name)}
            </option>
          ))}
        </select>
      </div>

      {/* Footer */}
      <div className="text-gray-600 text-sm mt-6">
        Powered by <span className="font-semibold">AICA</span> | Your Smart Health Assistant for Parents
      </div>
    </div>
  );
};

export default FrontPage;
